(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            // #region addRandomCell
            key: "addRandomCell",
            value: function addRandomCell() {
                var clearBoard = [];
                for(var i = 0; i < this.board.length; i++){
                    for(var j = 0; j < this.board[i].length; j++)if (this.board[i][j] === 0) clearBoard.push([
                        i,
                        j
                    ]);
                }
                if (clearBoard.length === 0) return;
                var randomIndex = Math.floor(Math.random() * clearBoard.length);
                var randomCell = clearBoard[randomIndex];
                var randomValue = Math.random() > 0.1 ? 2 : 4;
                this.board[randomCell[0]][randomCell[1]] = randomValue;
            }
        },
        {
            // #endregion
            // #region moveMethods
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "playing") return;
                var move = false;
                for(var i = 0; i < this.board.length; i++){
                    var oldRow = (0, $227c6742e0ff6f82$export$71511d61b312f219)(this.board[i]);
                    var newRow = [];
                    for(var j = 0; j < this.board[i].length; j++)if (this.board[i][j] !== 0) newRow.push(this.board[i][j]);
                    for(var v = 0; v < newRow.length; v++)if (newRow[v] === newRow[v + 1]) {
                        var newValue = newRow[v] * 2;
                        newRow.splice(v + 1, 1);
                        newRow[v] = newValue;
                        this.score += newValue;
                        if (newValue === 2048) this.status = "win";
                        v++;
                    }
                    while(newRow.length < 4)newRow.push(0);
                    for(var index = 0; index < oldRow.length; index++)if (oldRow[index] !== newRow[index]) {
                        move = true;
                        break;
                    }
                    this.board[i] = newRow;
                }
                if (move === true) this.addRandomCell();
                if (this.status === "playing") this.ifLose();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                for(var i = 0; i < this.board.length; i++)this.board[i].reverse();
                this.moveLeft();
                for(var i1 = 0; i1 < this.board.length; i1++)this.board[i1].reverse();
            }
        },
        {
            key: "transposeBoard",
            value: function transposeBoard() {
                var newBoard = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                for(var i = 0; i < this.board.length; i++)for(var j = 0; j < this.board[i].length; j++)newBoard[j][i] = this.board[i][j];
                this.board = newBoard;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.transposeBoard();
                this.moveLeft();
                this.transposeBoard();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.transposeBoard();
                for(var i = 0; i < this.board.length; i++)this.board[i].reverse();
                this.moveLeft();
                for(var i1 = 0; i1 < this.board.length; i1++)this.board[i1].reverse();
                this.transposeBoard();
            }
        },
        {
            // #endregion
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status !== "idle") return;
                this.status = "playing";
                this.addRandomCell();
                this.addRandomCell();
            }
        },
        {
            key: "ifLose",
            value: function ifLose() {
                for(var i = 0; i < this.board.length; i++)for(var j = 0; j < this.board[i].length; j++){
                    if (this.board[i][j] === 0) return;
                    if (j < 3) {
                        if (this.board[i][j] === this.board[i][j + 1]) return;
                    }
                    if (i < 3) {
                        if (this.board[i][j] === this.board[i + 1][j]) return;
                    }
                }
                this.status = "lose";
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                this.score = 0;
                this.status = "idle";
            }
        }
    ]);
    return Game;
}();
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


"use strict";
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$btnStart = document.querySelector("button.start");
var $197cd56b15c33885$var$allCell = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$myScore = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$bestScoreEl = document.querySelector(".best-score");
var $197cd56b15c33885$var$bestScore = Number(localStorage.getItem("bestScore")) || 0;
$197cd56b15c33885$var$bestScoreEl.textContent = $197cd56b15c33885$var$bestScore;
$197cd56b15c33885$var$btnStart.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$renderBoard();
        $197cd56b15c33885$var$myScore.textContent = $197cd56b15c33885$var$game.getScore();
        $197cd56b15c33885$var$btnStart.textContent = "Restart";
        $197cd56b15c33885$var$btnStart.classList.add("restart");
        $197cd56b15c33885$var$btnStart.classList.remove("start");
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$renderBoard();
        $197cd56b15c33885$var$myScore.textContent = "0";
        $197cd56b15c33885$var$btnStart.textContent = "Start";
        $197cd56b15c33885$var$btnStart.classList.remove("restart");
        $197cd56b15c33885$var$btnStart.classList.add("start");
        $197cd56b15c33885$var$messageLose.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.add("hidden");
        $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    }
});
document.addEventListener("keydown", function(e) {
    if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight") e.preventDefault();
    if (e.key === "ArrowLeft") $197cd56b15c33885$var$game.moveLeft();
    if (e.key === "ArrowRight") $197cd56b15c33885$var$game.moveRight();
    if (e.key === "ArrowUp") $197cd56b15c33885$var$game.moveUp();
    if (e.key === "ArrowDown") $197cd56b15c33885$var$game.moveDown();
    $197cd56b15c33885$var$renderBoard();
    $197cd56b15c33885$var$myScore.textContent = $197cd56b15c33885$var$game.getScore();
    if ($197cd56b15c33885$var$game.getScore() > $197cd56b15c33885$var$bestScore) {
        $197cd56b15c33885$var$bestScore = $197cd56b15c33885$var$game.getScore();
        $197cd56b15c33885$var$bestScoreEl.textContent = $197cd56b15c33885$var$bestScore;
        localStorage.setItem("bestScore", $197cd56b15c33885$var$bestScore);
    }
    if ($197cd56b15c33885$var$game.getStatus() === "win") {
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    }
    if ($197cd56b15c33885$var$game.getStatus() === "lose") {
        $197cd56b15c33885$var$messageStart.classList.add("hidden");
        $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    }
    if ($197cd56b15c33885$var$game.getStatus() === "playing") $197cd56b15c33885$var$messageStart.classList.add("hidden");
});
function $197cd56b15c33885$var$renderBoard() {
    for(var i = 0; i < $197cd56b15c33885$var$game.getState().length; i++)for(var j = 0; j < $197cd56b15c33885$var$game.getState()[i].length; j++){
        var cell = $197cd56b15c33885$var$allCell[i * 4 + j];
        cell.textContent = "";
        cell.className = "field-cell";
        if ($197cd56b15c33885$var$game.getState()[i][j] !== 0) {
            cell.textContent = $197cd56b15c33885$var$game.getState()[i][j];
            cell.classList.add("field-cell--".concat($197cd56b15c33885$var$game.getState()[i][j]));
        }
    }
}
var $197cd56b15c33885$var$btnMobile = document.querySelectorAll(".mobile-controls button");
$197cd56b15c33885$var$btnMobile.forEach(function(button) {
    button.addEventListener("click", function() {
        if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
        var direction = button.dataset.move;
        if (direction === "left") $197cd56b15c33885$var$game.moveLeft();
        if (direction === "right") $197cd56b15c33885$var$game.moveRight();
        if (direction === "up") $197cd56b15c33885$var$game.moveUp();
        if (direction === "down") $197cd56b15c33885$var$game.moveDown();
        $197cd56b15c33885$var$renderBoard();
        $197cd56b15c33885$var$myScore.textContent = $197cd56b15c33885$var$game.getScore();
        if ($197cd56b15c33885$var$game.getStatus() === "win") {
            $197cd56b15c33885$var$messageStart.classList.add("hidden");
            $197cd56b15c33885$var$messageWin.classList.remove("hidden");
        }
        if ($197cd56b15c33885$var$game.getStatus() === "lose") {
            $197cd56b15c33885$var$messageStart.classList.add("hidden");
            $197cd56b15c33885$var$messageLose.classList.remove("hidden");
        }
        if ($197cd56b15c33885$var$game.getStatus() === "playing") $197cd56b15c33885$var$messageStart.classList.add("hidden");
    });
});

})();
//# sourceMappingURL=index.4bd6b123.js.map
